import WorkshopVideoBlock from './WorkshopVideoBlock';

export default WorkshopVideoBlock;
